module.exports = {"TXTWCL_Something_went_wrongX_please_t_ELL":{"id":"TXTWCL_Something_went_wrongX_please_t_ELL","defaultMessage":"不具合が発生しました。再度お試しください。"}}